const iq = (translations) => translations?.inquiry || {}

export const getPricingRateLabel = (consignment, translations) => {
  const t = iq(translations)
  if (consignment?.BillingUnit === 2) return t.ratePerUnit || 'Rate per Unit'
  if (consignment?.BillingUnit === 1 && consignment?.IsKgKm) return t.ratePerKgKm || 'Rate per KG-KM'
  return t.ratePerKg || 'Rate per KG'
}

export const getBranchDetailLabels = (translations) => {
  const t = iq(translations)
  return {
    BranchName: t.branchName || 'BranchName',
    Address: t.address || 'Address',
    Contact: t.contact || 'Contact',
    LocationURL: t.locationUrl || 'LocationURL',
  }
}
